import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { usePeriodicRead } from './usePeriodicRead';
import { countsByLane } from '../components/relations/relationsInbox';

const POLL_MS = 60_000;

/**
 * Compteur « à répondre » pour le badge nav Relations (léger poll 60s).
 */
export function useRelationsUnreadCount(): number {
  const [count, setCount] = useState(0);

  const fetchCount = useCallback(async () => {
    const { data } = await supabase.rpc('get_relations_inbox_counts');
    if (data) setCount(countsByLane(data).reply ?? 0);
  }, []);

  useEffect(() => {
    void fetchCount();
  }, [fetchCount]);
  usePeriodicRead(() => void fetchCount(), POLL_MS);

  return count;
}
